import { useParams } from 'react-router-dom';

import ProductDetailsView from './ProductsDetailsView';

interface ProductDetailsChangeProps {
  enroll?: boolean;
}

const ProductDetailsChange = ({ enroll }: ProductDetailsChangeProps) => {
  const { productSlug, productClassUuid } = useParams();

  return <ProductDetailsView productSlug={productSlug} productClassUuid={productClassUuid} enroll={enroll} />;
};

export default ProductDetailsChange;
